import * as React from "react";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { FC } from "react";

interface IProps {
  orderCount: number;
  page: number;
  handlePageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
}

const PaginationComponent: FC<IProps> = ({
  orderCount = 1,
  page,
  handlePageChange,
}) => {
  /*   const setPageCount = () => {
    let x = orderCount / 15;
    return Math.trunc(x) + 1;
  } */

  return (
    <Stack spacing={2}>
      {/* <Typography>Page: {page}</Typography> */}
      <Pagination
        count={Math.trunc(orderCount / 15) + 1}
        page={page}
        onChange={handlePageChange}
      />
    </Stack>
  );
};

export default PaginationComponent;
